import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=12cb76f4&scoped=true"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=12cb76f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb76f4",
  null
  
)

export default component.exports